import { render, staticRenderFns } from "./BOSSCustomer.vue?vue&type=template&id=ed274f98&scoped=true&"
import script from "./BOSSCustomer.vue?vue&type=script&lang=js&"
export * from "./BOSSCustomer.vue?vue&type=script&lang=js&"
import style0 from "./BOSSCustomer.vue?vue&type=style&index=0&id=ed274f98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed274f98",
  null
  
)

export default component.exports